import { PermissionSet, PermissionSetAssignment } from '../../../types';
import { deriveAccessLevelKey, deriveScopeTypeKey } from './derivations';

export type PermissionSetFilterKey = 'all' | 'read_only' | 'full_access' | 'tag_based';

export interface PermissionSetFilterOption {
  key: PermissionSetFilterKey;
  label: string;
}

export const PERMISSION_SET_FILTERS: PermissionSetFilterOption[] = [
  { key: 'all', label: 'All' },
  { key: 'read_only', label: 'Read Only' },
  { key: 'full_access', label: 'Full Access' },
  { key: 'tag_based', label: 'Tag-Based' }
];

const matchesFilter = (set: PermissionSet, filter: PermissionSetFilterKey): boolean => {
  switch (filter) {
    case 'read_only':
      return deriveAccessLevelKey(set.rules) === 'read_only';
    case 'full_access':
      return deriveAccessLevelKey(set.rules) === 'full_access';
    case 'tag_based':
      return deriveScopeTypeKey(set.rules) === 'tag';
    default:
      return true;
  }
};

const matchesSearch = (set: PermissionSet, query: string): boolean =>
  !query || set.name.toLowerCase().includes(query) || (set.description ?? '').toLowerCase().includes(query);

export const filterPermissionSets = (
  sets: PermissionSet[],
  filter: PermissionSetFilterKey,
  search: string
): PermissionSet[] => {
  const query = search.trim().toLowerCase();
  return sets.filter((set) => matchesFilter(set, filter) && matchesSearch(set, query));
};

export const countUsersForSet = (
  assignments: PermissionSetAssignment[],
  setId: string,
  teamMemberCount: (teamId: number) => number = () => 0
): number =>
  assignments
    .filter((assignment) => assignment.permission_set_id === setId)
    .reduce((sum, assignment) => sum + (assignment.team_id != null ? teamMemberCount(assignment.team_id) : 1), 0);
